import en from "./en.json";
import ja from "./ja.json";
import ko from "./ko.json";
import zh from "./zh.json";

const translations = { en, ja, ko, zh };

export default translations;
